import getMatrixType from "@secureo/common/utils/getMatrixType"
import { DispatchLockingSystemReducer, LockingSystemReducerState } from ".."

export type SpecialMatrixType = "single" | "simultaneous"

type SetSpecialMatrixTypePayload = Pick<LockingSystemReducerState, "matrix" | "matrixType">

const getSingleMatrixTypeMatrix = (currentMatrix: LockingSystemReducerState["matrix"]) => {
	const specialMatrix: LockingSystemReducerState["matrix"] = []

	for (let rowCounter = 0; rowCounter < currentMatrix.length; rowCounter++) {
		const row = []
		for (
			let columnCounter = 0;
			columnCounter < currentMatrix[rowCounter].length;
			columnCounter++
		) {
			row[columnCounter] = rowCounter === columnCounter
		}

		specialMatrix.push(row)
	}

	return specialMatrix
}

const getSimultaneousMatrixTypeMatrix = (currentMatrix: LockingSystemReducerState["matrix"]) => {
	const specialMatrix: LockingSystemReducerState["matrix"] = []

	for (let rowCounter = 0; rowCounter < currentMatrix.length; rowCounter++) {
		const row = []

		for (
			let columnCounter = 0;
			columnCounter < currentMatrix?.[rowCounter].length;
			columnCounter++
		) {
			row[columnCounter] = true
		}

		specialMatrix.push(row)
	}

	return specialMatrix
}

const getSpecialMatrixTypeMatrix = (
	currentMatrix: LockingSystemReducerState["matrix"],
	matrixType: SpecialMatrixType,
) => {
	switch (matrixType) {
		case "single":
			return getSingleMatrixTypeMatrix(currentMatrix)
		case "simultaneous":
			return getSimultaneousMatrixTypeMatrix(currentMatrix)
	}
}

export const setSpecialMatrixType = (
	dispatch: DispatchLockingSystemReducer,
	currentMatrix: LockingSystemReducerState["matrix"],
	matrixType: SpecialMatrixType,
) => {
	const numberOfRows = currentMatrix.length
	const numberOfColumns = currentMatrix?.[0].length
	// Omit if matrix has 0 rows or 0 columns
	if (numberOfRows === 0 || numberOfColumns === 0) return

	const matrix = getSpecialMatrixTypeMatrix(currentMatrix, matrixType)

	const payload: SetSpecialMatrixTypePayload = {
		matrix,
		matrixType: getMatrixType(matrix),
	}

	dispatch({
		type: "SET_SPECIAL_MATRIX_TYPE",
		payload,
	})
}
